<script lang="ts" setup>
  import type { StateMachineContext } from '~/models/StateMachineModels'
  import { ProfileStore } from '~/stores/profile'
  import { PlanType } from '~/generated/api-clients-generated'
  import type { PushToSaveScenarios } from '~/composables/PushToSave'

  const props = defineProps<{
    context: StateMachineContext
    presentation: string
  }>()

  const scenario = computed(() => (props.context?.config ?? 'add-needs') as PushToSaveScenarios)
  const { data } = await PushToSaveContent.use(scenario.value)

  const screen = computed(() => data.value?.screens?.successSignIn)

  const profile = ProfileStore.use()
  const session = SessionStore.use()
  const { hydratePlaceholders } = Cms.use()

  const successMessage = computed(() =>
    hydratePlaceholders(screen.value?.message ?? '', {
      identifier: profile.firstName || ''
    })
  )

  const source = computed(() => props.context.data.get('source'))

  const { sendOutboundRequest } = OutboundLead.use()

  onMounted(async () => {
    if (
      (profile.primaryContactPhone || session.outboundLeadPhone) &&
      session.planType === PlanType.MAPD
    ) {
      await sendOutboundRequest(
        profile.emailAddress?.address ?? '',
        profile.primaryContactPhone?.number ?? session.outboundLeadPhone!,
        source.value
      )
    }
  })
</script>

<template>
  <section class="grid place-content-center place-items-center gap-3">
    <span class="text-5xl leading-none">{{ screen?.icon }}</span>
    <h2 class="text-center" v-html="successMessage"></h2>
    <HpButton v-if="props.presentation !== 'inline'" class="mt-7 max-w-72" @click="context.data.get('onComplete')?.()">Close</HpButton>
  </section>
</template>

<style scoped></style>
